const useAD = process.env.REACT_APP_USE_AD === 'true'

export default useAD
